// Audio chime player
(function () {
  const rows = document.querySelectorAll('.chime-row');
  let current = null;

  rows.forEach(function (row) {
    const src = row.dataset.audio;
    if (!src) return;
    const audio = new Audio(src);

    row.addEventListener('click', function () {
      if (current && current.audio !== audio) {
        current.audio.pause();
        current.audio.currentTime = 0;
        current.row.classList.remove('playing');
        current.row.querySelector('.play-btn').textContent = '\u25B6';
      }

      if (audio.paused) {
        audio.play();
        row.classList.add('playing');
        row.querySelector('.play-btn').textContent = '\u275A\u275A';
        current = { audio: audio, row: row };
      } else {
        audio.pause();
        audio.currentTime = 0;
        row.classList.remove('playing');
        row.querySelector('.play-btn').textContent = '\u25B6';
        current = null;
      }

      audio.onended = function () {
        row.classList.remove('playing');
        row.querySelector('.play-btn').textContent = '\u25B6';
        current = null;
      };
    });
  });
})();

// ============================================
// SCROLL-REVEAL ANIMATIONS
// ============================================
(function () {
  var els = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });
})();

// ============================================
// PRODUCT PAGE INTERACTIONS
// ============================================
(function () {
  // Gallery thumbnails
  var thumbs = document.querySelectorAll('.thumb');
  var mainImg = document.getElementById('mainImg');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      if (mainImg && t.dataset.src) mainImg.src = t.dataset.src;
    });
  });

  // Quantity
  window.chQty = function (d) {
    var span = document.getElementById('qty');
    var input = document.getElementById('qty-input');
    if (!span) return;
    var q = Math.max(1, parseInt(span.textContent, 10) + d);
    span.textContent = q;
    if (input) input.value = q;
  };

  // Variant option buttons -> update hidden select + price
  var select = document.getElementById('variant-select');
  var optionGroups = document.querySelectorAll('.size-opts[data-option-index], .swatches[data-option-index]');
  var priceEl = document.getElementById('price');
  var compareEl = document.getElementById('compare');

  function currentSelections() {
    var sel = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.variant-option.active');
      sel[parseInt(group.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
    });
    return sel;
  }

  function updateVariant() {
    if (!select) return;
    var sel = currentSelections();
    var options = select.querySelectorAll('option');
    options.forEach(function (opt) {
      // Shopify variant title is "Val1 / Val2 / Val3"
      var parts = opt.textContent.trim().split(' / ');
      var match = sel.every(function (v, i) { return v == null || parts[i] === v; });
      if (match) {
        opt.selected = true;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (compareEl && opt.dataset.compare) compareEl.textContent = opt.dataset.compare;
      }
    });
  }

  document.querySelectorAll('.variant-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.size-opts, .swatches');
      group.querySelectorAll('.variant-option').forEach(function (x) { x.classList.remove('active'); });
      btn.classList.add('active');
      // Update the "— ColorName" label next to a swatch group, if present
      if (group.classList.contains('swatches')) {
        var idx = group.dataset.optionIndex;
        var label = document.querySelector('.opt-selected[data-option-index="' + idx + '"]');
        if (label && btn.dataset.name) label.textContent = '— ' + btn.dataset.name;
      }
      updateVariant();
    });
  });

  // Inline audio preview on product page
  var listenBtn = document.getElementById('listenBtn');
  if (listenBtn && listenBtn.dataset.audio) {
    var audio = new Audio(listenBtn.dataset.audio);
    listenBtn.addEventListener('click', function () {
      if (audio.paused) {
        audio.play();
        listenBtn.classList.add('playing');
        listenBtn.querySelector('.play-btn').textContent = '\u275A\u275A';
      } else {
        audio.pause(); audio.currentTime = 0;
        listenBtn.classList.remove('playing');
        listenBtn.querySelector('.play-btn').textContent = '\u25B6';
      }
      audio.onended = function () {
        listenBtn.classList.remove('playing');
        listenBtn.querySelector('.play-btn').textContent = '\u25B6';
      };
    });
  }
})();
